module.exports = __webpack_public_path__ + "img/part5.9f7fd448.png";